import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "MidApp.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.Res_ENUM_Gender_None = null;
this.Res_ENUM_Gender_Mr = null;
this.Res_ENUM_Gender_Mrs = null;
}

static translate: TranslateService;
_key: any;
Res_ENUM_Gender_None:any;
Res_ENUM_Gender_Mr:any;
Res_ENUM_Gender_Mrs:any;




}